import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons'
import { Popover } from 'antd'
import ActiveListingPopover from './TableComponents/ActiveListingPopover'
import { useAppSelector } from 'hooks'
import { useMemo } from 'react'
import { getPricelistName } from 'Helpers/PricesHelper'
import { BaseStorePricelist } from 'Constants/Configuration'
import { renderTranslation } from 'Helpers/GenericHelpers'
import { TranslationKeys } from 'Constants/TranslationKeys'

/**
 * @param {any} isColumnOpen;
 * @param {any} isColumnMinified;
 * @param {function} setIsColumnOpen;
 * @param {boolean} showPrice;
 * @param {number} basePrice;
 * @param {string} invariantInfo
 * @param {bool} isBySize
 * @param {string} language
 */

export default function PricesListingHeader(props) {
  const channelType = useAppSelector(state => state.present.price.channelType)
  const popoverTriggerContent = useMemo(
    () =>
      props.showPrice ? (
        <>
          <div className='text-underline cursor-pointer float-left ml-4'>
            {props.activeListing == BaseStorePricelist && props.invariantInfo
              ? renderTranslation(props.language, TranslationKeys.pricelistBaseStore)
              : `${getPricelistName(props.activeListing, props.language)} ${props.invariantInfo}`}
          </div>
          {props.invariantInfo ? null : <div className='float-right mr-1 w-60-p text-right'>{props.basePrice}€</div>}
        </>
      ) : (
        <>
          <span className='text-underline cursor-pointer d-flex  justify-center'>
            {getPricelistName(props.activeListing, props.language)}
          </span>
        </>
      ),
    [props.showPrice, props.activeListing, props.basePrice],
  )

  return (
    <div className='listing-table-head-box multi-table-head'>
      {props.isColumnOpen ? (
        <>
          <CaretLeftOutlined
            className='listing-collapse-icon multi-table-collapse-icon'
            onClick={() => {
              props.setIsColumnOpen(false)
            }}
          />
          <ActiveListingPopover
            activeListing={props.activeListing}
            basePrice={props.basePrice}
            channelType={channelType}
            showPopoverContent={true}
            id={'active-listing-popover'}
            popoverTriggerContent={popoverTriggerContent}
          />
        </>
      ) : (
        <>
          {props.isColumnMinified ? (
            <Popover content={props.activeListing} className='popover-listing multi-table-popover' trigger='hover'>
              <CaretRightOutlined
                className='multi-table-collapse-icon'
                onClick={() => {
                  props.setIsColumnOpen(true)
                }}
              />
            </Popover>
          ) : (
            <Popover content={props.activeListing} className='popover-listing multi-table-popover' trigger='hover'>
              <CaretRightOutlined
                className='multi-table-collapse-icon'
                onClick={() => {
                  props.setIsColumnOpen(true)
                }}
              />
            </Popover>
          )}
        </>
      )}
    </div>
  )
}
